import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES, routeKeyFor, useLang } from "../i18n/LangContext";

const SITE = "https://starvynt.com";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/** Per-page title, description, canonical, hreflang and social preview tags. */
export const Seo = () => {
  const { pathname } = useLocation();
  const { t, lang } = useLang();
  useEffect(() => {
    const key = routeKeyFor(pathname);
    const [title, desc] = t.seo[key];
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", SITE + ROUTES[key][lang]);
    setMeta("property", "og:locale", lang === "es" ? "es_US" : "en_US");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", desc);
    setLink("canonical", SITE + ROUTES[key][lang]);
    setLink("alternate", SITE + ROUTES[key].en, "en");
    setLink("alternate", SITE + ROUTES[key].es, "es");
    setLink("alternate", SITE + ROUTES[key].en, "x-default");
    window.scrollTo(0, 0);
  }, [pathname, t, lang]);
  return null;
};
